import styled from 'styled-components';
import Button from 'sushiweb/Button';
import Input from 'sushiweb/InputTypes/Input';
import Layout from 'sushiweb/Layout/Layout';
import Modal from 'sushiweb/Modal';
import grey from 'sushiweb/tokens/color/grey';
import red from 'sushiweb/tokens/color/red';
import H4 from 'sushiweb/Typography/Heading/H4';

export const PageLayout = styled(Layout)`
  background-color: white;

  .only-mobile {
    display: none;
  }

  @media (max-width: 768px) {
    .only-desktop {
      display: none;
    }
    .only-mobile {
      display: flex;
    }
  }
`;

export const Fold1Container = styled(Layout.Item)`
  width: 100%;
  background: linear-gradient(0deg, #ffffff 0%, #fff7fa 100%);
}
`;

export const Fold2Container = styled(Layout.Item)`
  height: max(auto, 100vh)
  width: 100%;
  padding: 6% 16% 3%;
  background: linear-gradient(180deg, #ffffff 0%, #f8f9fc 100%);

  @media (max-width: 768px) {
    padding: 15% 10%;
  }

  @media (min-width: 1920px) {
    padding: 6% 20%;
  }
`;

export const Fold1SVGLeftContainer = styled.div`
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;

  svg {
    width: 40vw;
    height: 40vw;
  }
`;

export const Fold1SVGRightContainer = styled.div`
  position: absolute;
  overflow: hidden;
  top: 0;
  right: 0;

  svg {
    width: 30vw;
    height: 30vw;
  }
`;

export const Fold3Container = styled(Layout.Item)`
  width: 100%;
  background-color: white;
  padding: 0 12% 3%;

  @media (max-width: 768px) {
    padding: 15% 5%;
  }
  @media (min-width: 1920px) {
    padding: 0 20% 5%;
  }
`;

export const Fold4Container = styled(Layout.Item)`
  width: 100%;
  background-color: white;
  padding: 0% 16%;

  @media (max-width: 768px) {
    padding: 3% 5%;
  }
  @media (min-width: 1920px) {
    padding: 6% 20% 0;
  }
`;

export const Fold4SVGContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  div {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  img {
    width: 50%;
  }
`;

export const Fold5Container = styled(Layout.Item)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  margin: 0;
  padding: 0;
`;

export const CheersFoldContainer = styled(Layout.Item)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 5% 0 -3% 0;
  padding: 0;

  svg {
    position: absolute;
    margin-right: 20%;
    margin-bottom: 10%;
  }

  @media (max-width: 768px) {
    svg {
      margin-right: 40%;
      margin-bottom: 20%;
    }
  }
`;

export const Fold6Container = styled(Layout.Item)`
  width: 100%;
  background-color: white;
  padding: 6% 16% 0;

  @media (max-width: 768px) {
    padding: 15% 5%;
  }
  @media (min-width: 1920px) {
    padding: 6% 20% 0;
  }
`;

export const StyledNavbar = styled(Layout)`
  position: fixed;
  justify-content: space-between;
  padding: 2rem 5%;
  z-index: 100;
  border-bottom: none;

  @media (min-width: 768px) {
    background-color: ${({ scrolled }) => (scrolled ? '#fff' : 'transparent')};
    box-shadow: ${({ scrolled }) =>
    scrolled ? '0px 3px 6px rgba(0, 0, 0, 0.05)' : 'none'};
    transition: background-color 200ms linear, border-bottom 200ms linear,
      box-shadow 200ms linear;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: ${grey.z200};
      opacity: ${({ scrolled }) => (scrolled ? 1 : 0)};
      transition: opacity 200ms linear;
    }
  }

  @media (max-width: 768px) {
    position: relative;
    background-color: transparent;
    transition: none;
  }
`;

const getTransformValue = (scrolled, isModalOpen) => {
  if (scrolled) {
    return isModalOpen ? 'translateY(100%)' : 'translateY(0)';
  }
  return 'translateY(100%)';
};

export const StyledNavbarMobile = styled(Layout)`
  position: fixed;
  width: 100vw;
  bottom: 0;
  align-items: center;
  justify-content: center;
  padding: 5% 0%;
  z-index: 100;
  border-top: none;

  h1 {
    display: flex;
    justify-content: flex-end;
    font-family: 'Lexend-500';
    font-size: 4.5vw;
    color: ${grey.z900};
  }
  background: ${({ scrolled }) =>
    scrolled
      ? 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(245, 182, 182, 0.6) 100%)'
      : 'transparent'};
  transition: transform 200ms ease-in-out, opacity 400ms ease-in-out,
    background 400ms ease-in-out;
  transform: ${({ scrolled, isModalOpen }) =>
    getTransformValue(scrolled, isModalOpen)};
`;

export const ZLogoWrapper = styled(Layout.Item)`
  display: flex;
  justify-content: flex-start;

  @media (max-width: 768px) {
    img {
      height: 30px;
    }
  }
`;

export const ZLogoWrapperFooter = styled(Layout.Item)`
  display: flex;
  flex-direction: column;
  margin-top: 2%;
  align-items: flex-start;
  justify-content: flex-start;

  img {
    width: 40%;
    margin-bottom: 6%;
  }

  svg {
    height: 70%;
  }
`;

export const ConnectButton = styled(Layout.Item)`
  display: flex;
  justify-content: flex-end;
  animation: fadeSlideIn 0.4s ease-out;

  @keyframes fadeSlideIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  button {
    font-family: 'Lexend-500';
  }
`;

export const ConnectStickyButton = styled(Layout.Item)`
  display: flex;
  justify-content: center;

  button {
    font-family: 'Lexend-500';
  }
`;

export const Fold1Content = styled(Layout.Item)`
  display: flex;
  padding: 0rem 8%;
  align-items: center;
  width: 100%;
  justify-content: center;
  flex-direction: column;

  margin-top: 10%;

  &.only-desktop {
    > .bOHpvh {
      align-items: center;
      flex-direction: row;
      gap: 3rem;
    }

    .layout-item:first-child {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      text-align: left;

      > div {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
      }

      h1 {
        text-align: left;
        font-size: 5.5rem;
        margin-bottom: 0.5rem;
      }

      h4 {
        text-align: left;
        margin-top: 2rem;
      }

      svg {
        display: none;
      }
    }

    .layout-item:last-child {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  > div:not(.bOHpvh) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  h1 {
    font-family: 'Lexend-500';
    font-size: min(4.5vw, 8rem);
    text-align: center;
    color: ${grey.z900};
    letter-spacing: -0.03em;
    line-height: 1.1;

    .red {
      font-family: 'PlayfairDisplayItalic-500';
      color: ${red.z500};
      padding-left: 2.1rem;
      padding-bottom: 1rem;
    }
  }

  h4 {
    font-family: 'Lexend-400';
    font-size: 2rem;
    color: ${grey.z600};
    margin-top: 2%;

    svg {
      padding: 0;
      margin: 0;
      vertical-align: middle;
    }
  }

  button {
    margin-top: 3%;
    width: 20rem;
    height: 5rem;
  }

  svg {
    margin-left: 37rem;
    margin-top: -3rem;
  }

  @media (max-width: 768px) {
    padding: 0rem 5%;
    margin-top: 30%;
    h1 {
      font-size: 9.4vw;
      text-align: center;

      .red {
        padding-bottom: 1rem;
        margin-left: -1.9rem;
      }
    }
    h4 {
      margin-top: 3%;
      font-size: 4vw;
      text-wrap: nowrap;

      img {
        width: 25px;
      }
    }
    button {
      margin-top: 5%;
      width: 15rem;
      height: 5rem;
    }
    svg {
      margin-left: 4rem;
      margin-top: -2rem;
      width: 80%;
      height: 80%;
    }
  }
`;

export const ConnectNowButton = styled(Button)`
  box-shadow: 0px 16px 32px 0px rgba(239, 79, 95, 0.2);
  font-family: 'Lexend-500';
  z-index: 1;

  @media (min-width: 769px) {
    &.only-mobile {
      display: none;
    }
  }
`;

export const InlineFormWrapper = styled.div`
  background: white;
  border-radius: 1.5rem;
  padding: 2.5rem 2rem;
  box-shadow: 0px 24px 48px rgba(0, 0, 0, 0.06);
  width: 100%;
  max-width: 430px;
  border: 1px solid rgba(255, 255, 255, 0.08);

  h4 {
    text-align: center;
    margin-bottom: 2rem;
    font-family: 'Lexend-600';
    color: ${grey.z800};
    font-size: 2.5rem;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const TestimonialSlidingContainer = styled(Layout.Item)`
  margin-top: 8%;
  width: 100%;
  gap: 2rem;
  overflow: hidden;
  white-space: nowrap;

  @media (max-width: 768px) {
    margin-top: 18%;
  }
`;

export const TestimonialSlider = styled.div`
  display: inline-flex;
  margin-right: 50px;
  width: 360px;
  background-color: ${grey.z100};
  border-radius: 2rem;

  @media (max-width: 768px) {
    width: 320px;
    margin-right: 30px;
  }
`;

export const TestimonialSlide = styled(Layout)`
  display: inline-flex;
  width: 100%;
  background-color: ${grey.z100};
  border-radius: 2rem;
  padding-right: 1rem;
`;

export const TestimonialLogoContainer = styled(Layout.Item)`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;

  svg {
    background-color: white;
    border-radius: 15px;
    padding: 0.8rem;

    width: 100%;
    height: 100%;
  }
`;

export const TestimonialContent = styled(Layout.Item)`
  display: flex;
  flex-direction: column;
  padding: 2rem 0;

  h4 {
    font-family: 'Lexend-500';
    font-size: 1.5rem;
    text-wrap: nowrap;
    color: ${grey.z900};
  }
  p {
    margin: 0;
    font-family: 'Lexend-300';
    font-size: 1.3rem;
    color: ${grey.z600};
    margin-top: 0.5rem;
  }

  @media (max-width: 768px) {
    h4 {
      font-size: 1.3rem;
    }
    p {
      margin-top: 0.3rem;
      font-size: 1.1rem;
    }
  }
`;

export const Fold2Heading = styled(Layout.Item)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2rem 0;
    margin-bottom: 5%;
  }

  h1 {
    padding: 0;
    font-family: 'Lexend-500';
    margin-top: 3%;
    text-align: center;
    color: ${grey.z900};
    font-size: min(max(3vw, 3rem), 5rem);
  }

  h2 {
    margin-top: -1rem;
    padding: 0;
    font-family: 'PlayfairDisplayItalic-500';
    color: ${red.z500};
    font-size: min(max(3vw, 3rem), 5rem);
  }

  span {
    font-family: 'Lexend-500';
    font-size: min(max(3vw, 3rem), 5rem);
    color: ${grey.z900};
  }

  .red {
    font-family: 'PlayfairDisplay-500';
    color: ${red.z500};
  }
`;

export const Fold3Heading = styled(Layout.Item)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 5%;
  padding: 5rem 0 0 0;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  h1 {
    padding: 0;
    font-family: 'Lexend-500';
    margin-top: 7%;
    text-align: center;
    color: ${grey.z900};
    font-size: min(max(3vw, 3rem), 5rem);
  }

  span {
    font-family: 'PlayfairDisplayItalic-500';
    color: ${red.z500};
    font-size: min(max(3vw, 3rem), 5rem);
    margin-top: -2%;
  }
`;

export const Fold3HeadingMobile = styled(Layout.Item)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  h1 {
    padding: 0;
    font-family: 'Lexend-500';
    margin-top: 7%;
    text-align: center;
    color: ${grey.z900};
    font-size: min(max(3vw, 3rem), 5rem);
  }

  span {
    font-family: 'PlayfairDisplayItalic-500';
    color: ${red.z500};
    font-size: min(max(3vw, 3rem), 5rem);
    margin-top: -2%;
  }
`;

export const HeaderPill = styled.div`
  display: flex;
  justify-content: center;
  width: fit-content;
  align-items: center;
  background-color: ${grey.z100};
  border-radius: 2rem;
  padding: 0.8rem 2rem !important;
  font-family: 'Lexend-400';
  color: ${grey.z900};
  font-size: max(1rem, 0.8vw);
`;

export const Fold2Cards = styled(Layout.Item)`
  display: flex;
  align-items: center;
  flex-direction: column;

  div {
    display: flex;
    flex-direction: column;
    align-items: center !important;
    padding: 2rem;
    gap: 2rem;
    height: 100%;
  }

  h4 {
    margin-top: 1rem;
    font-family: 'Lexend-500';
    font-size: max(1.2vw, 1.6rem);
    text-align: center;
    color: ${grey.z900};
  }

  p {
    margin: 0;
    padding: 0;
    width: 80%;
    font-family: 'Lexend-300';
    font-size: max(0.8vw, 1.4rem);
    color: ${grey.z600};
    text-align: center;
  }

  svg {
    width: 25%;
    height: 25%;
  }

  @media (max-width: 768px) {
    gap: 5%;
    padding: 2%;

    svg {
      width: 32%;
      height: 32%;
    }
  }
`;

export const Fold4Cards = styled(Layout.Item)`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 2rem;

  div {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 2rem;
  }

  h4 {
    margin-top: 1rem;
    font-family: 'Lexend-500';
    font-size: max(1.2vw, 1.6rem);
    text-align: center;
    color: ${grey.z900};
  }

  p {
    margin: 0;
    padding: 0;
    width: 80%;
    font-family: 'Lexend-300';
    font-size: max(0.8vw, 1.4rem);
    color: ${grey.z600};
    text-align: center;
  }

  svg {
    height: 35%;
  }

  @media (max-width: 768px) {
    gap: 5%;
    padding: 2%;

    svg {
      width: 25%;
      height: auto;
      max-width: 80px;
    }

    p {
      text-align: center;
    }
  }
  @media (min-width: 1920px) {
    padding: 2% 0;
  }
`;

export const Fold2CardsContainer = styled(Layout)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: 0;
  padding: 0;
}
`;

export const Fold2CardsMobileContainer = styled(Layout.Item)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  transform-style: preserve-3d;

  div {
    display: flex;
    width: 100%;
  transform-style: preserve-3d;
    }


  .back, .front {
    backface-visibility: hidden;
  }

  .back {
  position: absolute;
  top: 0;
  left: 0;
    transform: rotateY(180deg);
    -webkit-transform: rotateY(180deg);
  -moz-transform: rotateY(180deg);
  -ms-transform: rotateY(180deg);
  -o-transform: rotateY(180deg);
  `;

export const Fold2CardsMobile = styled(Layout.Item)`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 15rem;
  padding: 7% 5%;
  gap: 8%;
  margin-top: 8%;

  border-radius: 17.791px;
  background: #fff;
  filter: drop-shadow(-4px 4px 10px rgba(0, 0, 0, 0.05));

  h4 {
    margin-top: 1rem;
    font-family: 'Lexend-500';
    font-size: min(2rem, max(4vw, 1.4rem));
    text-align: center;
    color: ${grey.z900};
    user-select: none;
  }

  p {
    margin: 0;
    padding: 0;
    width: 80%;
    font-family: 'Lexend-300';
    font-size: min(2rem, max(0.8vw, 1.2rem));
    color: ${grey.z600};
    text-align: center;
    user-select: none;
  }

  svg {
    width: 35%;
    height: 35%;
  }

  img {
    height: min(35%, 40px);
  }
`;

export const Fold3Left = styled(Layout.Item)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
  padding: 2rem;
  margin-top: -5%;
  gap: 2rem;

  div {
    display: flex;
    width: 100%;
  }

  span {
    margin: 0;
    padding: 0;
    font-family: 'PlayfairDisplayItalic-500';
    font-size: min(max(3vw, 3rem), 5rem);
    color: ${red.z500};
  }

  h1 {
    font-family: 'Lexend-500';
    font-size: min(max(3vw, 3rem), 5rem);
    color: ${grey.z900};
    margin-bottom: 5%;
  }
  @media (max-width: 768px) {
    align-items: center !important;
    width: 100%;

    h1 {
      margin: 0;
    }
    span {
      margin-top: -2rem;
    }
  }
`;

export const Fold3Right = styled(Layout.Item)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 5%;

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    // padding-left: 5%;
  }
  img {
    width: 80%;
    max-width: 70rem;
  }

  @media (max-width: 1000px) {
    display: none;
  }
`;

export const WhyUsCard = styled(Layout)`
  display: flex;
  border-radius: 24px;
  border: 1px solid var(--color-base-grey-200, #e6e9ef);
  background: #fff;
  box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.02);

  @media (max-width: 768px) {
    border-radius: 18px;
  }
`;

export const WhyUsCardLeft = styled(Layout.Item)`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;

  svg {
    padding: 0;
  }
`;

export const WhyUsCardRight = styled(Layout.Item)`
  display: flex;
  flex-direction: column;
  padding: 2rem 2rem 2rem 0;

  h4 {
    font-family: 'Lexend-500';
    font-size: max(1.5rem, 1vw);
    color: ${grey.z900};
  }

  p {
    margin: 0;
    padding-top: 4px;
    font-family: 'Lexend-300';
    font-size: max(1.2rem, 0.7vw);
    color: ${grey.z600};
  }
`;

export const SavingsContainer = styled(Layout)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5%;
  padding: 2% 10% 0%;

  @media (max-width: 768px) {
    padding: 2% 5% 0;
  }
`;

export const ZeroContainer = styled(Layout)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  width: 100%;

  div {
    display: flex;
    width: 100%;
  }
`;

export const StrikethroughContainer = styled.span`
  position: relative;
  display: inline-block;

  svg {
    position: absolute;
    top: 10%;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export const CrownContainer = styled.span`
  position: relative;
  display: inline-block;

  svg {
    position: absolute;
    top: 20%;
    right: -18%;
    width: 70%;
    height: 70%;
  }

  @media (max-width: 768px) {
    svg {
      right: -17%;
      top: 26%;
    }
  }

  @media (min-width: 1920px) {
    svg {
      right: -20%;
      top: 5%;
    }
  }
`;

export const SavingsHeader = styled(Layout.Item)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2%;

  div {
    justify-content: center !important;

    span {
      z-index: 1;
      display: flex;
      justify-content: center;
      text-align: center;
    }
  }
  h1 {
    z-index: 1;
    font-family: 'Lexend-500';
    font-size: min(max(3vw, 3rem), 5rem);
    color: ${grey.z900};
  }

  span {
    z-index: 1;
    display: flex;
    justify-content: center;
    text-align: center;
  }

  .red {
    font-family: 'PlayfairDisplayItalic-500';
    font-size: min(max(3vw, 3rem), 5rem);
    color: ${red.z500};
    margin-top: -2%;
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const VerticalLineSVGContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 15rem;
  margin-top: 2rem;

  svg {
    height: 100%;
    width: auto;
  }
`;

export const SavingsCardContainer = styled(Layout)`
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: 0;
`;

export const ZeroCardContainer = styled(Layout)`
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: 0 2%;
`;

export const SavingsCard = styled(Layout.Item)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 8% 0 0 0;

  padding: 2%;
  gap: 2%;
  border-radius: 40px;
  border: 0;
  background: linear-gradient(180deg, #fff 0%, #fff 100%);
  box-shadow: 0px 24px 40px 0px rgba(250, 230, 237, 0.6);

  svg {
    width: 40%;
    margin-bottom: 8%;
  }

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      margin-bottom: 3%;
      margin-top: 6%;
    }
    svg.savings-percentage-svg {
      transform: scale(1.9);
    }
  }

  h4 {
    font-family: 'Lexend-500';
    font-size: min(max(2rem, 1.5vw), 3rem);
    color: ${grey.z900};
    text-align: center;
  }

  p {
    font-family: 'Lexend-300';
    font-size: max(1.2rem, 0.7vw);
    color: ${grey.z600};
    text-align: center;
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 40px;
    padding: 3px;
    background: linear-gradient(
      0deg,
      rgba(250, 230, 237, 0.8),
      rgba(250, 230, 237, 0)
    );
    mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
    mask-composite: exclude;
  }

  @media (max-width: 768px) {
    padding: 4% 4%;
    border-radius: 30px;
    border: 0;

    background: linear-gradient(180deg, #fff 0%, #fff 100%);

    box-shadow: 0px 17.566px 29.276px 0px rgba(250, 230, 237, 0.6);
    align-items: center;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 30px;
      padding: 1px;
      background: linear-gradient(
        0deg,
        rgba(250, 230, 237, 0.8),
        rgba(250, 230, 237, 0)
      );
      mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
      mask-composite: exclude;
    }

    svg {
      margin-bottom: -10%;
      padding: 0;
      width: 50%;
    }

    div {
      display: flex;
      justify-content: center;
      align-items: center;
      svg {
        align: center;
        margin-bottom: 0%;
        margin-top: 3%;
      }
    }
    h4 {
      padding: 0;
      margin: 0;
      text-align: center;
      font-size: 3.5vw;
    }
    p {
      margin-top: 4%;
      text-align: center;
      font-size: 1.1rem;
    }

    img {
      width: 100%;
      margin-bottom: 8%;
    }
  }
`;

export const SaingsSVGContainer = styled.div`
  position: absolute;
  top: -60%;
  z-index: 0;
  overflow: visible;

  svg {
    width: 100vw;
    overflow: visible;
  }

  @media (max-width: 768px) {
    top: -800%;
  }

  @media (min-width: 1920px) {
    top: -30%;
  }
`;

export const ZeroSVGContainer = styled.div`
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  margin-top: 2%;
  z-index: 0;
  top: 25%;
  left: 20;

  div {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  img {
    width: 30%;
  }

  @media (min-width: 1920px) {
    top: 25%;
  }
`;

export const ZeroCard = styled(Layout.Item)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 14% 0;
  width: 100%;

  padding: 1rem;
  gap: 4%;
  border-radius: 100px;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0px 20px 40px 0px #f1f1f1;
  backdrop-filter: blur(20px);

  h4 {
    font-family: 'Lexend-500';
    font-size: max(1.6rem, 0.75vw);
    color: ${grey.z900};
  }

  @media (min-width: 1920px) {
    margin: 12% 0 5%;
  }
`;

export const Strip = styled(Layout.Item)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2% 20%;
  background: linear-gradient(180deg, ${red.z50} 40%, ${red.z200} 100%);

  h1 {
    text-align: center;
    text-wrap: wrap;
    font-family: 'PlayfairDisplayItalic-500';
    font-size: min(max(1.8rem, 2.5vw), 4rem);
    color: ${red.z500};
  }

  @media (max-width: 768px) {
    padding: 0% 4%;

    svg {
      height: 2rem;
    }

    h1 {
      display: flex;
      justify-content: center;
      width: 80%;
      align-items: center;
      text-align: center;
      font-size: 1.5rem;
    }
  }
`;

export const RedRectangle = styled.div`
  margin-top: -30rem;
  background-color: ${red.z50};
  width: 100vw;
  height: 30rem;
  z-index: 1.5;
`;

export const WhiteBox = styled.div`
  background-color: ${red.z100};
  width: 90%;
  height: 40rem;
  margin-top: -40rem;
  border-radius: 40px 40px 0 0;
  border: 4px solid var(--color-base-white, #fff);
  background: #fff;
  box-shadow: 0px -20px 40px 0px rgba(0, 0, 0, 0.02);
`;

export const DashboardViewSVGContainer = styled.div`
  z-index: 2;
  width: 60vw;

  div {
    width: 60vw;
  }

  img {
    border-radius: 20px 20px 0 0;
    width: inherit;
  }
`;

export const LogoCardContainer = styled(Layout)`
  display: flex;
  justify-content: space-between;
  margin0-bottom: 0;

  @media (max-width: 768px) {
    padding: 0 20%;
  }
  @media (min-width: 1920px) {
    padding: 0 15%;
  }
`;

export const LogoCard = styled(Layout.Item)`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  margin: 5% 0;
  border-radius: 40px;
  background: #fff;
  box-shadow: 0px 20px 40px 0px rgba(0, 0, 0, 0.04);

  svg {
    padding: 15%;
    width: 100%;
    height: 100%;
  }

  @media (max-width: 768px) {
    border-radius: 20px;
    height: 10rem;
  }
`;

export const Footer = styled.footer`
  width: 100%;
  padding: 4rem 0 0 5%;
  background: #f9fafd;

  @media (max-width: 768px) {
    padding-bottom: 20%;
  }
`;

export const FooterContent = styled(Layout)`
  display: flex;
  justify-content: space-between;
  padding: 0 0 2% 2%;
`;

export const FooterText = styled(Layout.Item)`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: flex-start;
  gap: 1.2rem;
  margin: 0;
  padding: 0;

  #footer_image {
    position: absolute;
    right: 0;
    width: 150% !important;
    margin-top: 10%;
  }

  h4 {
    margin-top: 10%;
    font-family: 'Lexend-500';
    font-size: max(1.5rem, 1vw);
    color: ${grey.z900};
  }

  p {
    margin: 0;
    font-family: 'Lexend-300';
    font-size: max(1.2rem, 0.8vw);
    color: ${grey.z600};
  }
`;

export const StyledModal = styled(Modal)`
  width: 100%;

  h1 {
    font-family: 'Lexend-500';
    font-size: min(max(2vw, 2rem), 3rem);
    color: ${grey.z900};
  }
`;

export const ModalContainer = styled.div`
  max-width: 35rem;
  min-width: 20rem;
  margin-top: 2rem;

  button {
    width: 100%;
    padding: 0;
  }

  @media (max-width: 768px) {
    min-width: 20rem;
    max-width: 40rem;
    width: none;

    button {
      width: 100%;
    }
  }
`;

export const LeadSuccessWrapper = styled(Layout)`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  h1 {
    text-align: center;
  }
  h4 {
    font-family: 'Lexend-300';
    font-size: 1.4rem;
    text-align: center;
  }
`;

export const IconWrapper = styled(Layout.Item)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledInput = styled(Input)`
  width: 100%;

  label {
    padding-left: 0.5rem;
    font-size: ${props => (props.value ? '1.1rem' : '1.5rem')};
    color: #767c8f;
  }

  &:focus-within label {
    font-size: 1.1rem;
    font-weight: 500;
    color: #119199;
  }

  &:not(:focus-within) label {
    color: ${props => (props.hasError && props.value ? red.z700 : '#767C8F')};
  }

  section {
    input {
      padding-left: 4.1rem;
      font-size: 1.7rem;
      border-color: ${props => (props.hasError ? red.z700 : grey.z200)};

      &:focus {
        border-color: #119199 !important;
        border-width: 0.1rem !important;
      }
    }
  }
`;

export const CarouselContainer = styled.div`
  width: 100%;
  max-width: 100vw;
  height: auto;
  max-height: 40%;
  margin: 5% 10% 5% 10%;
  overflow: hidden;
  z-index: 1;

  @media (max-width: 768px) {
    margin: 0 0 0 0;
    width: 100vw;
    height: 15%;
  }
`;

export const CheersSlideContainer = styled(Layout)`
  display: flex;
  border-radius: 26px;
  border: 1px solid #fff;
  padding: 2rem !important;

  background: #fff;

  box-shadow: 0px 10px 40px 0px rgba(250, 230, 237, 0.8);
  overflow: hidden;

  @media (max-width: 768px) {
    margin: 0;
    padding: 2rem !important;
  }
}
`;

export const CheersSlideImageContainer = styled(Layout.Item)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  border: 1px solid #fff;
  overflow: hidden;
  padding: 0 !important;
  flex-shrink: 0;

  img {
    width: 100%;
    height: auto;
  }
`;

export const CheersSlideContent = styled(Layout.Item)`
  padding: 2% 2% 0 4% !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 2rem;

  h1 {
    font-family: 'Lexend-500';
    font-size: min(max(2vw, 1.8rem), 4rem);
    color: ${grey.z900};
  }
  p {
    font-family: 'Lexend-300';
    font-size: max(1.4rem, 1.1vw);
    color: ${grey.z800};
    margin: 0;
  }
  h4 {
    font-family: 'Lexend-500';
    font-size: max(1.6rem, 1.2vw);
    color: ${grey.z900};
    margin: 0;
    padding: 0;
  }

  @media (max-width: 768px) {
    padding: 5% 0 2% 0 !important;
    h1 {
      font-size: 1.8rem;
    }
    p {
      font-size: 1.2rem;
    }
    h4 {
      font-size: 1.8rem;
    }
  }
`;

export const CheersSlideFooter = styled(Layout)`
  display: flex;
  width: 100%;
  gap: 1rem;
  flex-direction: column;

  hr {
    border: 1px solid ${grey.z200};
  }
`;

export const CheersSlideSign = styled(Layout)`
  display: flex;
  width: 100%;
`;

export const CheersSlideSignLeft = styled(Layout.Item)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 !important;
`;

export const CheersSlideSignRight = styled(Layout.Item)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 !important;

  svg {
    width: 70%;
    height: 70%;
    margin: 0 0 0 40%;
  }

  @media (max-width: 768px) {
    svg {
      width: 60%;
      height: 60%;
    }
  }
`;

export const ErrorContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  h4 {
    color: ${red.z700};
    font-size: max(1.35rem, 1vw);
    font-family: 'Lexend-300';
    padding-bottom: 0.7rem;
  }

  @media (min-width: 768px) {
    h4 {
      font-size: 1.35rem;
    }
  }
`;

export const ErrorContainerV2 = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left !important;
  color: ${red.z700};
  font-size: 1.35rem;
  font-family: 'Lexend-300';
  text-align: left !important;
  margin: 0;
`;

export const StyledSvg = styled.div``;

export const CarouselDesktopWrapper = styled.div`
  width: 100%;
  padding: 4rem 10rem;
  overflow: hidden;
`;

export const CarouselMobileWrapper = styled.div`
  width: 100%;
  padding: 4rem;
  overflow: hidden;
`;

export const Fold1DesktopWrapper = styled.div`
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  width: 100%;
  gap: 3rem;
`;

export const Fold1TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 8rem;
`;

export const Fold1FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const LeadFormLayout = styled(Layout)`
  padding-left: 1rem;
  padding-right: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LeadFormTitle = styled(H4)`
  margin-bottom: 3rem;
  margin-left: -7rem;
  color: #374151;
`;

export const InputIconWrapper = styled.div`
  margin-left: -37rem;
  margin-top: 1.3rem;
`;

export const ModalInputIconWrapper = styled.div`
  margin-top: -2px;
`;

export const ModalButtonWrapper = styled(Layout.Item)`
  padding: 0;
`;

export const MarqueeWrapper = styled.div`
  display: inline-block;
`;
